/**
 * @prettier
 * @flow
 */
import type { Environment } from 'src/constants/Environment';
import { Environments } from 'src/constants/Environment';

export function terminalApiCode(environment?: Environment): string {
    switch (environment) {
        case Environments.LOCALHOST:
            return 'vpcYDZ_0y1b5uKB-8FFCPis5OBtYpMtw266kmgIwLULTAzFuv7vuVw==';
        case Environments.TEST:
            return 'vpcYDZ_0y1b5uKB-8FFCPis5OBtYpMtw266kmgIwLULTAzFuv7vuVw==';
        case Environments.PROD:
            return 'Kc1Ip7llsCounOmnBaU0QXb8mSTZlTgP2yyyyfm3xlo2sAFfXUBulQ==';
        default:
            throw new Error(`Invalid argument environment=${environment ?? 'undefined'}`);
    }
}
